'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pressData = exports.pressData = function pressData() {
  return {
    mainImage: {
      mobile: require('../../../../../static/img/mock-data/pricing/press/main-image.png'),
      desktop: require('../../../../../static/img/mock-data/pricing/press/main-image-dektop.png')
    },
    quotes: [{
      copy: 'ClassPass offers a considerable leap in efficiency and convenience, paired with a price cut that seems too good to be true.',
      source: 'The New York Times',
      image: require('../../../../../static/img/mock-data/pricing/press/logo-nyt.png')
    }, {
      copy: 'ClassPass’s monthly memberships are a great value, considering most classes cost upwards of $30 each at retail pricing or drop-ins.',
      source: 'Well + Good',
      image: require('../../../../../static/img/mock-data/pricing/press/logo-wg.png')
    }]
  };
};